
import { AccountPopupMenu } from "./AccountPopupMenu";
import { navigatePath } from "../../nav/actions";
import { connect } from "react-redux";

const mapDispatchToProps = dispatch => {
  return {
    navigatePath: path => dispatch(navigatePath(path)),
  };
};

const mapStateToProps = state => {
  return {
    tda: state.tda,
    user: state.user,
    client: state.client,
    dwolla: state.dwolla,
    onboarding: state.onboarding,
    app: state.app,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountPopupMenu);
